import { DELETE_MESSAGE, LOAD_CATEGORIES, LOAD_THREAD, LOAD_THREADS, POST_THREAD, POST_REPLY } from './actions';

const initialState = {
  // All available categories in the forum
  categories: [],

  // Threads in the given category selected
  threads: [],

  // The current thread displaying
  thread: {
    messages: [],
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_CATEGORIES.SUCCESS:
      return {
        ...state,
        categories: action.payload.categories.map(cat => ({
          slug: cat.toLowerCase(),
          name: cat,
        })),
      };
    case LOAD_THREAD.SUCCESS:
      return {
        ...state,
        thread: action.payload.thread,
      };
    case LOAD_THREAD.REQUEST:
      return {
        ...state,
        thread: initialState.thread,
      };
    case LOAD_THREAD.FAIL:
      return {
        ...state,
        thread: {
          error: action.code,
          messages: [],
        },
      };
    case LOAD_THREADS.SUCCESS:
      return {
        ...state,
        threads: action.payload.threads,
      };
    case POST_THREAD.SUCCESS:
      return {
        ...state,
        threads: [{
          ...action.payload.thread,
          author: action.data.author,
          title: action.data.thread.title,
          excerpt: action.data.thread.content.substring(0, 120),
          tags: [{ slug: action.data.thread.category, name: action.data.thread.category }],
          time: new Date(),
          answers: 1,
        },
        ...state.threads,
        ],
      };
    case POST_REPLY.SUCCESS:
      return {
        ...state,
        thread: {
          ...state.thread,
          messages: [
            ...state.thread.messages,
            {
              id: action.payload.message.id,
              author: action.data.author,
              content: action.data.content,
              time: new Date(),
            }
          ]
        },
      };
    case DELETE_MESSAGE.SUCCESS:
      return {
        ...state,
        thread: {
          ...state.thread,
          answers: state.thread.answers - 1,
          messages: state.thread.messages.filter(msg => msg.id !== action.data.thread.messageId),
        },
      };
    default:
      return state;
  }
}